import React from "react";
import aiPlan from "../../../assets/images/DietPlans/diet-plan-feature/caloriePlan.svg";
import report from "../../../assets/images/DietPlans/diet-plan-feature/report.png";
import Curated from "../../../assets/images/DietPlans/Curated.png";
import Star53 from "../../../assets/images/DietPlans/star53.svg";
import guardians from "../../../assets/images/DietPlans/diet-plan-feature/guardians.png";
import waterTracker from "../../../assets/images/DietPlans/diet-plan-feature/waterTracker.png";
import estimatedHba1C from "../../../assets/images/DietPlans/diet-plan-feature/estimatedHba1C.png";
import AIAccordianPlan from "../../../assets/images/DietPlans/AIAccordianPlan.svg";
import AIAccordianClosePlan from "../../../assets/images/DietPlans/AIAccordianClosePlan.svg";

const featurePoint = [
  {
    icon: aiPlan,
    title: "Calorie tracking",
    description: "Count every calorie—stay on track, no excuses!",
  },
  {
    icon: report,
    title: "Report Insights",
    description:
      "Unlock powerful insights—see your progress, own your success!",
  },
  {
    icon: guardians,
    title: "Health guardians",
    description: "Your health, your rules—stay guided, stay unbeatable! ",
  },
  {
    icon: waterTracker,
    title: "Water tracker",
    description: "Hydrate like a pro—track it, sip it, crush it!",
  },
  {
    icon: estimatedHba1C,
    title: "Estimated Hba1C",
    description: "Know your numbers—take charge, stay ahead of diabetes!",
  },
];

const dietPlanAI = [
  {
    id: 1,
    label: "Curated Diet Plan",
    planImage: Curated,
    closePlanImage: Curated,
    subList: [
      { id: 1, name: "Designed by Expert Nutritionists" },
      { id: 2, name: "Based on your health goals" },
      { id: 3, name: "Curated by experts" },
    ],
  },
];
const dietPlanSheet = [
  {
    id: 2,
    label: "Generated AI Diet plans",
    planImage: AIAccordianPlan,
    closePlanImage: AIAccordianClosePlan,
    subList: [
      { id: 1, name: "Desinged by our Properiery AI" },
      { id: 2, name: "Based on your health data on Dr Trust app" },
      { id: 3, name: "Based on your dietary preferences" },
      { id: 4, name: "Based on your health goals" },
      { id: 5, name: "Food items popular in your region" },
      { id: 6, name: "Unique plan tailored to your exact needs" },
    ],
  },
];

const Feature = ({ dietPlan }) => {
  let selectedPlanType = dietPlan?.dietPlanType;
  const plan =
    selectedPlanType === "one_month_ai_diet_plan_autopay_subscription"
      ? dietPlanSheet
      : dietPlanAI;
  return (
    <div>
      {/* {plan?.map((v) => (
        <div key={v} className="card-container">
          <div className="card-container-inner">
            <div style={{ height: 65, marginRight: "10px" }}>
              <img
                className=""
                src={v?.planImage}
                alt="star"
                loading="lazy"
                height="100%"
              />
            </div>
            <div>
              <h4> {v?.label}</h4>
              <ul
                style={{ listStyleType: "none", padding: 0, marginBottom: 0 }}
              >
                {v?.subList.map((list) => (
                  <li key={list?.id}>
                    <span>
                      <img style={{ marginBottom: "4px" }} src={Star53} />
                    </span>
                    <span> {list?.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))} */}
      <div className="feature-main my-3 p-4">
        {featurePoint.map((obj, i) => (
          <div key={i} className="plan-feature d-flex mb-4 align-items-center">
            <img src={obj.icon} alt="" loading="lazy" />
            <div>
              <h2>{obj.title}</h2>
              <p>{obj.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Feature;
